import goIcon from '../../static/icons/go.jpg'
import javascriptIcon from '../../static/icons/javascript.jpg'
import pythonIcon from '../../static/icons/python.jpg'
import html5Icon from '../../static/icons/html5.jpg'
import reactIcon from '../../static/icons/react.jpg'
import nodejsIcon from '../../static/icons/nodejs.jpg'
import nextjsIcon from '../../static/icons/nextjs.jpg'
import echoIcon from '../../static/icons/echo.jpg'
import mongodbIcon from '../../static/icons/mongodb.jpg'
import postgresIcon from '../../static/icons/postgres.jpg'
import firebaseIcon from '../../static/icons/firebase.jpg'
import sassIcon from '../../static/icons/sass.jpg'
import materializeIcon from '../../static/icons/materialize.jpg'
import bootstrapIcon from '../../static/icons/bootstrap.jpg'

const skills = [
  {
    image: goIcon,
    label: 'Go (Golang)'
  },
  {
    image: javascriptIcon,
    label: 'Javascript'
  },
  {
    image: pythonIcon,
    label: 'Python'
  },
  {
    image: html5Icon,
    label: 'HTML5'
  },
  {
    image: reactIcon,
    label: 'React'
  },
  {
    image: nodejsIcon,
    label: 'Nodejs'
  },
  {
    image: nextjsIcon,
    label: 'Nextjs'
  },
  {
    image: echoIcon,
    label: 'Echo'
  },
  {
    image: mongodbIcon,
    label: 'MongoDB'
  },
  {
    image: postgresIcon,
    label: 'PostgreSQL'
  },
  {
    image: firebaseIcon,
    label: 'FireBase'
  },
  {
    image: sassIcon,
    label: 'Sass'
  },
  {
    image: materializeIcon,
    label: 'Materialize'
  },
  {
    image: bootstrapIcon,
    label: 'Bootstrap'
  }
]

export default skills
